export default __webpack_public_path__ + "static/media/xth.4c8e22df.svg";